import type { AuthMeetingDTOType, AuthMeetingResponseType } from '@/features/meetings/types'
import fetchClient from '@/lib/fetch'

export const V1_MEETING_QUERY_KEY = 'meeting'

export async function getAuthMeeting(data: AuthMeetingDTOType): Promise<AuthMeetingResponseType> {
  return fetchClient(`/v1/meeting/room?meetingRoomId=${data.meetingRoomId}`, {
    method: 'GET',
  })
}

export async function trackMeetingEnter(meetingRoomId: string): Promise<{ id: string }> {
  return fetchClient('/v1/meeting/tracking/enter', {
    method: 'POST',
    body: JSON.stringify({ meetingRoomId }),
  })
}

export async function trackMeetingExit(trackingId: string): Promise<void> {
  return fetchClient('/v1/meeting/tracking/exit', {
    method: 'POST',
    body: JSON.stringify({ id: trackingId }),
  })
}

export async function trackMeetingToggle(trackingId: string, type: 'microphone' | 'camera'): Promise<void> {
  return fetchClient('/v1/meeting/tracking/toggle', {
    method: 'POST',
    body: JSON.stringify({ id: trackingId, type }),
  })
}
